export const enum Steps {
  PersonalInfo = '1',
  AccountType = '2',
  BusinessInfo = 'business',
  EmployeeInfo = 'employee',
  RegistrationComplete = '5',
}
